import clamp from 'common/lib/clamp';
import Radium from 'radium';
import styles from './styles.less';
import { findDOMNode } from 'react-dom';
import { Link } from 'react-router';
import { observer } from 'mobx-react';


const ClipLink = Radium(Link);


@Radium
@observer
class Clip extends React.Component {
    static propTypes = {
        highlightColor: React.PropTypes.string.isRequired,
        linkClassName: React.PropTypes.string,
        rolloverTextColor: React.PropTypes.string.isRequired,
        selected: React.PropTypes.bool.isRequired,
        textOnly: React.PropTypes.bool,
        video: React.PropTypes.object.isRequired
    };

    static defaultProps = {
        highlightColor: '#000000',
        rolloverTextColor: '#FFFFFF',
        selected: false,
        textOnly: false
    };

    componentDidMount() {
        if (!this.props.textOnly) {
            this.clampTitle();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.textOnly && prevProps.textOnly) {
            this.clampTitle();
        }
    }

    render() {
        const className = cx(styles.root, this.props.className, {
            [styles.selected]: this.props.selected
        });
        return (
            <div className={ className }>
                { this.props.textOnly && this.renderTextView() }
                { !this.props.textOnly && this.renderThumbView() }
            </div>
        );
    }

    renderTextView() {
        const { video } = this.props;
        const inlineStyles = this.getStyles();
        return (
            <ClipLink
                className={ cx(styles.textLink, this.props.linkClassName) }
                onClick={ this.props.onClick }
                style={ inlineStyles.textLink }
                to={ video.url }>
                { !!video.fullIdentifier &&
                <h5 className={ styles.identifier }>{ video.fullIdentifier }</h5> }
                <h4 className={ styles.title }>
                    { video.title } <span className={ styles.duration }>({ video.durationFormatted })</span>
                </h4>
                <p className={ styles.description }>{ video.description }</p>
            </ClipLink>
        );
    }

    renderThumbView() {
        const { video } = this.props;
        const inlineStyles = this.getStyles();
        return (
            <ClipLink
                className={ cx(styles.thumbLink, this.props.linkClassName) }
                onClick={ this.props.onClick }
                to={ video.url }>
                <div
                    className={ styles.thumbnailContainer }
                    style={ inlineStyles.thumbnailContainer }>
                    { !!video.thumbnail &&
                    <img
                        alt={ `${video.collectionTitle} - ${video.title}` }
                        className={ styles.thumbnail }
                        src={ video.thumbnail }
                    /> }
                    <span
                        className={ styles.duration }
                        style={ inlineStyles.duration }>
                        { video.durationFormatted }
                    </span>
                </div>
                <h4
                    className={ styles.title }
                    ref='title'
                    title={ video.title }>
                    { video.title }
                </h4>
                { !!video.fullIdentifier &&
                <h5 className={ styles.identifier }>{ video.fullIdentifier }</h5> }
            </ClipLink>
        );
    }

    clampTitle() {
        const $title = findDOMNode(this.refs.title);
        if ($title) {
            clamp($title, { clamp: 2 });
        }
    }

    getStyles() {
        const { highlightColor, rolloverTextColor, selected } = this.props;
        return {
            thumbnailContainer: [
                { backgroundColor: highlightColor },
                selected && { color: highlightColor }
            ],
            duration: [
                selected && { backgroundColor: highlightColor, color: rolloverTextColor }
            ],
            textLink: [
                !Modernizr.touch && { ':hover': { backgroundColor: highlightColor, color: rolloverTextColor } },
                selected && { backgroundColor: highlightColor, color: rolloverTextColor }
            ]
        };
    }
}


export default Clip;



/** WEBPACK FOOTER **
 ** ./src/show-page/components/clip/index.js
 **/